<template>
  <div id="sureSend">
    <div class="common-header">
      <es-breadcrumb>
        <es-breadcrumb-item :to="{ path: '/MyOrder' }">{{ $t('我的订单') }}</es-breadcrumb-item>
        <es-breadcrumb-item v-if="!detailInfo.isResale">{{ detailInfo.isResale ? $t('订单转售') : $t('订单授权') }}</es-breadcrumb-item>
        <es-breadcrumb-item>{{ detailInfo.isResale ? $t('转售确认') : $t('授权确认') }}</es-breadcrumb-item>
      </es-breadcrumb>
    </div>
    <divided />
    <div class="common-body">
      <div class="info">
        <p>
          <span class="mr-20">{{ detailInfo.productName }}</span>
        </p>
        <p>
          <span class="mr-20">{{ $t('订单编号：') }}{{ detailInfo.orderShowId }}</span>
        </p>
        <p v-if="!detailInfo.isResale">{{ $t('可使用方：') }}{{ userInfo.name }}、{{ userList.join('、') }}</p>
        <p v-else>
          <span class="color999">{{ $t('本次新增的被转售方信息如下：') }}</span>
        </p>
      </div>
      <div class="header" v-if="detailInfo.showAddServerButton">
        <span>{{ $t('快速选择：') }}</span>
        <div v-for="item in tags" :key="item.id" :class="{ active: selectedTags[item.tagsId] }" @click="changeTags(item)">
          {{ item.tagsName }}
        </div>
      </div>

      <div v-if="detailInfo.isResale">
        <es-row class="table-user-title">
          <es-col :span="8">{{ $t('被转售方') }}</es-col>
          <es-col :span="8" v-if="!detailInfo.isProductOrder">{{ $t('有效期') }}</es-col>
          <es-col :span="8">{{ $t('最大可用量') }}</es-col>
        </es-row>
        <div v-for="(item, index) in detailInfo.authList" :key="index">
          <es-row class="reSale-user-body">
            <es-col :span="8">
              <i
                class="el-icon-circle-plus-outline"
                v-if="!item.showDetail && detailInfo.showAddServerButton"
                @click="changeItem(item)"
              ></i>
              <i class="el-icon-remove-outline" v-if="item.showDetail && detailInfo.showAddServerButton" @click="changeItem(item)"></i>
              {{ item.oldName }}
            </es-col>
            <es-col :span="8" v-if="!detailInfo.isProductOrder">{{
              `${item.effectStartTime ? formatUtc(item.effectStartTime, 'day') : ''} ~ ${
                item.effectEndTime ? formatUtc(item.effectEndTime, 'day') : ''
              }`
            }}</es-col>
            <es-col :span="8">{{ item.selledAmount }}{{ detailInfo.unit }}</es-col>
          </es-row>
          <div v-if="detailInfo.showAddServerButton">
            <es-table :data="item.details" border v-show="item.showDetail" :row-class-name="tableRowClassName">
              <es-table-column type="index" :label="$t(`序号`)"></es-table-column>
              <es-table-column prop="productName" :label="$t(`服务名称`)"></es-table-column>
              <es-table-column prop="price" :label="$t(`实际价格（元/次）`)"></es-table-column>
            </es-table>
          </div>
        </div>
      </div>
      <!-- 授权订单展示-->

      <div v-if="!detailInfo.isResale">
        <es-row class="table-user-title">
          <es-col :span="8">{{ $t('被授权方') }}</es-col>
          <es-col :span="8">{{ $t('授权订单总量/最大可用量') }}</es-col>
        </es-row>
        <div v-for="(item, index) in detailInfo.authList" :key="index">
          <es-row class="reSale-user-body">
            <es-col :span="8">
              {{ item.name }}
            </es-col>
            <es-col :span="8"
              >{{
                detailInfo.isUnLimitNum && item.authType === 0
                  ? $t('无限')
                  : detailInfo.unit === $t('元')
                  ? item.amount.toFixed(2) + detailInfo.unit
                  : item.amount + detailInfo.unit
              }}/{{ detailInfo.isUnLimitNum ? $t('无限') : detailInfo.margin + detailInfo.unit }}</es-col
            >
          </es-row>
        </div>
      </div>

      <div class="doc" v-if="!detailInfo.isResale">
        <p>{{ $t('授权须知：') }}</p>
        <p>
          {{
            $t(
              '在操作本转赠功能之前，请您仔细阅读本提醒内容，您实际使用了本功能即视为您已经阅读并认可本提醒内容；若您不接受本提醒内容，请您不要进行下一步操作。'
            )
          }}<br />
          {{
            $t(
              '1、本授权指：我司可将我司购买的e签宝服务中的全部或部分授权给我司提供的名单中的关联公司或合作伙伴。我司与授权使用方之间的法律关系由我司与授权使用方自行确认。'
            )
          }}<br />
          {{
            $t(
              '2、授权使用方使用e签宝服务的内容在e签宝提供的产品范围内，由我司确认。我司无条件接受e签宝调整可授权的产品范围，其影响由我司自行承担。'
            )
          }}<br />
          {{ $t('3、开通订单授权功能及进行授权，不改变我司与e签宝签署的《软件技术服务协议》等合同的权利义务关系，另有约定的除外。') }}<br />
          {{ $t('4、我司确保授权使用方完成实名认证，并按照电子签名法的要求合法合规使用电子签名服务。') }}<br />
          {{
            $t(
              '5、我司知悉e签宝非标类产品需要增购e签宝提供的《电子证据法律咨询服务》或《互联网业务流程公证服务》，我司确保可授权用户已经增购相应产品，否则贵司有权立刻关闭授权功能。'
            )
          }}
        </p>
      </div>

      <div class="doc" v-else>
        <p>{{ $t('转售须知：') }}</p>
        <p>
          {{
            $t(
              '在操作本转售功能之前，请您仔细阅读本提醒内容，您实际使用了本功能即视为您已经阅读并认可本提醒内容；若您不接受本提醒内容，请您不要进行下一步操作。'
            )
          }}<br />
          {{ $t('1、使用本功能，您可以将您所购买的e签宝服务中的全部或部分转售给您的关联公司、合作伙伴或者客户使用。') }}<br />
          {{ $t('2、使用本功能，不会改变您和e签宝所签署软件产品相关服务合同之权利义务关系，您需合法的使用该转售功能并自行对您的行为负责。')
          }}<br />
          {{
            $t(
              '3、您应确保您的转售使用方完成实名认证并按照电子签名法的要求合法合规的使用电子签名服务，e签宝不对您的转售使用方未按照法律规定使用电子签名的行为负责。'
            )
          }}<br />
          {{
            $t(
              '4、使用本功能，您应确保您已获得转售使用方给予您查看其使用电子签名签署记录的相关授权，并由您自行维护您与转售使用方间包括但不限于订单余额提醒、续充维护、隐私保护、费用结算、开票及其他相关服务，由此引发的争议由您自行处理，e签宝不承担任何责任。'
            )
          }}<br />
          {{
            $t(
              '5、因您的转售使用方与e签宝不存在合同关系，故您与您的转售使用方之间的法律关系由您自行负责，e签宝不向您的转售使用方提供出证等法律服务，您因确保您的转售使用方知晓并同意。'
            )
          }}<br />
          {{
            $t(
              '6、您因转售行为导致您的转售使用方不能正常使用电子签名服务或因使用服务引发纠纷的，您应自行处理，若因此给e签宝造成损失的，e签宝有权向您进行追偿。'
            )
          }}<br />
          {{ $t('7、e签宝保留随时关闭该功能的权利。') }}
        </p>
      </div>
      <div class="sure">
        <es-checkbox v-model="checked">{{ $t('我已阅读，同意此协议') }}</es-checkbox>
      </div>
      <div class="e-collapse-content" v-if="!isPartner">
        <p class="label">{{ $t('签署密码') }}</p>
        <div class="flex-row-start-center">
          <es-input
            v-model="signPassword"
            class="width-200"
            size="middle"
            type="password"
            :placeholder="$t('请输入签署密码进行') + (detailInfo.isResale ? $t('转售') : $t('授权'))"
          ></es-input>
          <p class="explain">{{ $t('还没有签署密码?') }}</p>
          <p class="a-link explain" @click="locationTo($Dic.getDefaultURL().setPwdUrl)">{{ $t('去设置签署密码') }}</p>
        </div>
      </div>
      <div style="height:120px" v-else>
        <div style="margin:20px" v-if="userInfo.contacts && userInfo.contacts.mobile">
          <span>{{ $t('手机号：') }}</span>
          <span>{{ userInfo.contacts.mobile }}</span>
        </div>
        <div v-else style="margin:20px">
          <span>{{ $t('邮箱：') }}</span>
          <span>{{ userInfo.contacts.email }}</span>
        </div>
        <div class="flex-row-start-center" style="margin:20px">
          <p class="label">{{ $t('验证码：') }}</p>
          <es-input v-model="authCheckCode" maxlength="6" style="width:300px" placeholder="请输入验证码">
            <es-button slot="append" :class="sending ? 'send-code-grey' : 'send-code'" @click="sendCode()">{{ codeBtnName }}</es-button>
          </es-input>
        </div>
      </div>
      <div class="footer">
        <es-button type="primary" @click="backEmpower()">{{ $t('上一步') }}</es-button>
        <es-button type="primary" @click="onSubmit" :disabled="!checked || !(authCheckCode || signPassword)">
          {{ detailInfo.isResale ? $t('确认转售') : $t('确认授权') }}
        </es-button>
      </div>
    </div>
  </div>
</template>
<script>
import { $t } from '@/locales'

import MD5 from 'js-md5'
import { mapState } from 'vuex'
import { formatUtc, debounce } from '@/util.js'
import divided from '../../components/divided'
import tsignData from '@tsign/tsigndata-sdk-js'

export default {
  components: {
    divided,
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      isOrg: state => state.isOrg,
      isPartner: state => state.isPartner,
    }),
  },
  data() {
    return {
      orderType: 0,
      selectedTags: {},
      tags: [],
      sending: false,
      formatUtc,
      checked: false,
      signPassword: '',
      authCheckCode: '',
      codeBtnName: '发送验证码',
      detailInfo: {
        authList: [],
      },
      userList: [],
    }
  },
  methods: {
    async sendCode() {
      if (this.sending) return
      this.sending = true
      const data = {
        authOrderId: this.detailInfo.orderId,
      }
      const wait = time =>
        new Promise(resolve => {
          setTimeout(() => resolve(), time)
        })
      this.$ajax(this.$url.sendCodeAuth(), data)
        .then(async res => {
          for (let index = 60; index > 0; index -= 1) {
            this.codeBtnName = `${index}s后重新获取`
            await wait(1000) // eslint-disable-line
          }
          this.codeBtnName = '重新获取'
          this.sending = false
        })
        // eslint-disable-next-line handle-callback-err
        .catch(err => {
          this.sending = false
        })
    },
    tableRowClassName({ row }) {
      if (row.tagIds && row.tagIds.some(item => this.selectedTags[item])) {
        return 'selected-row'
      }

      return ''
    },
    changeItem(item) {
      this.$set(item, 'showDetail', !item.showDetail)
    },
    onSubmit: debounce(
      async function onSubmit() {
        tsignData.track('PC_bill_Consent', { buttonName: 'authorization' })
        if (!this.checked) {
          return
        }
        if (!this.isPartner && !this.signPassword) {
          this.$message({
            type: 'info',
            message: $t('请输入签署密码进行授权'),
          })

          return
        } else if (this.isPartner && !this.authCheckCode) {
          this.$message({
            type: 'info',
            message: '请输入验证码进行授权',
          })
        }
        this.userInfo.orgId && (await this.$ajax(this.$url.space(this.userInfo.orgId)))
        if (this.detailInfo.isResale) {
          this.resaleSure()
        } else {
          this.authSure()
        }
      },
      2000,
      true
    ),

    changeTags(item) {
      this.$set(this.selectedTags, item.tagsId, !this.selectedTags[item.tagsId])
    },
    authSure() {
      const orderAuthCustomerReqList = []
      this.detailInfo.authList.forEach(element => {
        if (!element.isAjax) {
          orderAuthCustomerReqList.push({
            authedGid: element.gid,
            authType: element.authType,
            amount: element.authType === 0 ? '' : element.amount,
            authedGidName: element.name,
          })
        }
      })
      const data = {
        authOrderId: this.detailInfo.orderId,
        authProductId: this.detailInfo.productId,
        orderAuthCustomerReqList,
        orderType: this.orderType,
      }
      if (this.isPartner) {
        data.authCheckType = 'AUTH_CODE'
        data.authCheckCode = this.authCheckCode
      } else {
        data.authCheckType = 'PWD'
        data.infoPwdSign = MD5(this.signPassword)
      }
      this.$ajax(this.$url.orderAuthAdd(), data).then(() => {
        tsignData.track('PC_bill_Complete', { buttonName: 'authorization' })
        this.$message({
          type: 'success',
          message: $t('确认授权成功'),
        })
        this.$router.push({ path: '/MyOrder' })
      })
    },
    // 返回上一步
    backEmpower() {
      tsignData.track('PC_bill_Previous', { buttonName: 'authorization' })
      this.$router.push({
        path: '/empower',
        query: {
          authOrderId: this.detailInfo.orderId,
          type: 'MyOrder',
          source: 'sureSend',
          orderType: this.orderType,
        },
      })
    },
    resaleSure() {
      this.detailInfo.authList.map(item => (item.selledGid = item.guid))
      const data = {
        orderResellCustomerReqList: this.detailInfo.authList,
        infoPwdSign: MD5(this.signPassword),
        sellOrderId: this.detailInfo.orderId,
      }
      this.$ajax(this.$url.orderResellAdd(), data).then(() => {
        this.$message({
          type: 'success',
          message: $t('确认转售成功'),
        })
        this.$router.push({ path: '/MyOrder' })
      })
    },
    locationTo(arg) {
      window.open(arg)
    },
  },

  created() {
    this.detailInfo = JSON.parse(sessionStorage.getItem('detailInfo'))
    this.orderType = this.detailInfo.orderType * 1
    this.tags = JSON.parse(sessionStorage.getItem('tags'))

    this.detailInfo.authList.forEach((element, index) => {
      this.userList.push(element.name)
      if (index === 0) {
        this.changeItem(element)
      }
    })
  },
}
</script>
<style lang="less" scoped>
/deep/.selected-row {
  background: #edf5fd !important;
}
.send-code {
  color: #2981d9;
  cursor: pointer;
}

.send-code-grey {
  color: gray;
}
.color999 {
  color: #999999;
}
.mr-20 {
  margin-right: 20px;
}
.table-user-title {
  height: 42px;
  line-height: 42px;
  background: #fafafa;
  color: #333333;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0px 1px 0px 0px rgba(228, 228, 228, 1);
  padding: 0 20px;
}
.reSale-user-body {
  padding: 0 20px;
  height: 45px;
  line-height: 45px;
  box-shadow: 0px 1px 0px 0px #e4e4e4;
  color: #666;
  font-weight: 400;
}
.table-user-title,
.reSale-user-body {
  > .es-col:first-child {
    padding-left: 10px;
  }
}
.disabled {
  background-color: #999999 !important;
  cursor: not-allowed !important;
}

.width-200 {
  width: 200px;
}


.info {
  min-height: 100px;
  color: #232323ff;
  font-size: 14px;
  padding: 0 20px;
  border: 1px solid #f3f3f3;
  margin-bottom: 20px;

  box-shadow: 0px 0px 6px 0px #dce0ef;
  p {
    margin: 20px 0;
  }
}
.doc {
  margin-top: 20px;
  border: 1px solid #f3f3f3;
  font-size: 14px;
  color: #333333;
  padding: 0 20px;
  background: #f7f8fa;
  p:first-child {
    font-weight: 700;
  }
  p {
    margin: 10px 0;
    line-height: 20px;
    line-height: 30px;
  }
}
.sure {
  height: 40px;
  line-height: 40px;
  background: #f7f8fa;
  padding-left: 20px;
}
.e-collapse-content {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  height: 90px;
  .label {
    width: 60px;
    margin-right: 20px;
    font-size: 14px;
    color: #333333;
  }
}
.flex-row-start-center {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  .explain {
    font-size: 14px;
    color: #999999;
    line-height: 26px;
    height: 26px;
    margin-left: 10px;
  }
  .a-link {
    color: #1875f0;
    cursor: pointer;
  }
}
.header {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: row;
  align-content: center;
  margin-bottom: 10px;
  line-height: 40px;
  > div {
    cursor: pointer;
    padding: 0 10px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    font-size: 12px;
    color: #191f28;
    background: #ffffff;
    margin-right: 20px;
    border: 1px solid #eaebee;
  }
  .active {
    border: 1px solid #0975e0ff;
    position: relative;
  }
  .active::before {
    content: '';
    position: absolute;
    right: -1px;
    bottom: 0px;
    width: 0px;
    height: 0px;
    border-color: #0975e0ff transparent;
    border-width: 0px 0px 15px 15px;
    border-style: solid;
  }
  .active::after {
    content: '';
    position: absolute;
    right: 1px;
    bottom: 1px;
    width: 5px;
    height: 3px;
    border: 2px solid #fff;
    border-radius: 1px;
    border-top: none;
    border-right: none;
    background: transparent;
    transform: rotate(-45deg);
  }
}
.footer {
  display: flex;
  justify-content: flex-start;
  .button {
    margin-left: 40px;
  }
}
</style>
